"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var MaybeRenderHOC = function MaybeRenderHOC(_ref) {
  var shouldRender = _ref.shouldRender,
      children = _ref.children;

  if (shouldRender) {
    return _react.default.createElement("div", null, children);
  }

  return null;
};

MaybeRenderHOC.propTypes = {
  shouldRender: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node.isRequired
};
var _default = MaybeRenderHOC;
exports.default = _default;
module.exports = exports.default;